unique.datepicker = {
    init: function () {
        e4.require.js( e4.settings.require.datepicker, unique.datepicker.bindEvents );
    },
    bindEvents: function () {
        jQuery( '.js-unique-datepicker' ).datepicker( {} ).on( 'changeDate', function ( objEvent ) {
            unique.datepicker.updateDateInput( objEvent );
        } );
    },
    updateDateInput: function ( objEvent ) {
        var jTarget = jQuery( objEvent.target ),
            jDatePickerFormGroup = jTarget.closest( '.js-unique-datepicker-form-group' ),
            strDateFormat = jTarget.data( 'date-format' ).toLowerCase(),
            strDateFormatted = objEvent.format( strDateFormat );
        jDatePickerFormGroup.find( '.js-unique-datepicker-input' ).val( strDateFormatted );

        if ( jDatePickerFormGroup.is( '.js-unique-datepicker-form-group-with-split-values' ) === true ) {
            var intSelectedDay = objEvent.date.getDate(),
                intSelectedMonth = objEvent.date.getMonth() + 1,
                intSelectedYear = objEvent.date.getFullYear();
            jDatePickerFormGroup.find( '.js-unique-datepicker-split-value-day-input' ).val( intSelectedDay );
            jDatePickerFormGroup.find( '.js-unique-datepicker-split-value-month-input' ).val( intSelectedMonth );
            jDatePickerFormGroup.find( '.js-unique-datepicker-split-value-year-input' ).val( intSelectedYear );
        }
    }
};
